import { render, staticRenderFns } from "./ViewSale.vue?vue&type=template&id=2224e6a4&"
import script from "./ViewSale.vue?vue&type=script&lang=js&"
export * from "./ViewSale.vue?vue&type=script&lang=js&"
import style0 from "./ViewSale.vue?vue&type=style&index=0&id=2224e6a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports